import { LabelDescriptionOnTooltip } from '@aibees/elephant/components/label-description-on-tooltip';
import { useMapColorToChipColor } from '@aibees/elephant/hooks/use-map-color-to-chip-color';
import { ROUTES } from '@aibees/elephant/router';
import { LabelGrouping, LabelVisibility } from '@aibees/elephant/types/label';
import { Chip, TextEllipsis } from '@aibees/shared/components';
import { classnames } from '@aibees/shared/utils';
import { Box, Tooltip } from '@mui/material';
import { memo, useMemo } from 'react';
import * as Styled from './styles';
import * as SX from './sx';
import type { LabelNameProps as Props } from './types';

export const LabelName = memo(({ className, item }: Props) => {
  const isPeople = item.grouping === LabelGrouping.PEOPLE;
  const listId = encodeURIComponent(item.id);
  const param = encodeURIComponent(`${item.name}::${listId}`);
  const url = isPeople
    ? `${ROUTES.searchPeople}?labels_contact_include=${param}`
    : `${ROUTES.searchCompany}?labels_account_include=${param}`;

  const tooltipContent = item.description
    ? `${item.name} - ${item.description}`
    : item.name;
  const endIcon = useMemo(() => {
    return item.visibility === LabelVisibility.PRIVATE
      ? 'eye-lock-outline'
      : undefined;
  }, [item.visibility]);

  return (
    <Tooltip
      title={item.description && <LabelDescriptionOnTooltip label={item} />}
      placement="right"
    >
      <Styled.Wrapper
        className={classnames('LabelName', className)}
        sx={SX.root}
      >
        <Box sx={SX.chipWrapper}>
          <Chip
            label={
              <Styled.Link to={url} target="_blank">
                <TextEllipsis
                  value={item.name}
                  variant="body4"
                  showTooltip={true}
                  tooltipValue={tooltipContent}
                />
              </Styled.Link>
            }
            color={useMapColorToChipColor(item)}
            size="small"
            variant="filled"
            endIcon={endIcon}
          />
        </Box>
      </Styled.Wrapper>
    </Tooltip>
  );
});

LabelName.displayName = 'LabelName';
